import { useState, useEffect } from "react";
import { FETCH_SITES_COMPANY_ROLES, SAVE_PROJECTS_COMPAINES } from "../../constant/Apipath";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import moment from "moment/moment";
import CloseIcon from "@mui/icons-material/Close";
import { English } from "../../constant/EnglishFallback";

const AddRoleToCompanyModal = ({ open, onClose, data, onDataSave }) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  let currentUserId = loginData?.userInformation?.UserId ?? 0;

  const [rolesData, setRolesData] = useState([]);
  const [roleId, setRoleId] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [otherRoleName, setOtherRoleName] = useState("");
  const [otherValFlag, setOtherValFlag] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);

  const {
    TEXT_ADD_COMPANY_ROLE = English?.AddRoleToCompanyModal?.TEXT_ADD_COMPANY_ROLE,
    TEXT_LABEL_PROJECT = English?.AddRoleToCompanyModal?.TEXT_LABEL_PROJECT,
    TEXT_LET_KNOW_COMPANY_ROLE_PLAYED = English?.AddRoleToCompanyModal
      ?.TEXT_LET_KNOW_COMPANY_ROLE_PLAYED,
    TEXT_COMPANY_NAME = English?.AddRoleToCompanyModal?.TEXT_COMPANY_NAME,
    TEXT_ROLES = English?.AddRoleToCompanyModal?.TEXT_ROLES,
    BUTTON_CANCEL = English?.AddRoleToCompanyModal?.BUTTON_CANCEL,
    BUTTON_SAVE = English?.AddRoleToCompanyModal?.BUTTON_SAVE
  } = multiLanguageData?.AddRoleToCompanyModal || {};

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async () => {
    try {
      let obj = {
        SearchList: [{ userId: Number(currentUserId) }]
      };
      let res = await Postrequestcall(FETCH_SITES_COMPANY_ROLES, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];

      let a = [];
      const companyRoleData = resData?.map((value) => {
        a = value;
        a["label"] = value.name;
        return a;
      });
      setRolesData(companyRoleData);
    } catch (error) {
      console.log("getRoles-> Error Fetching Sites Company Roles: ", error);
    }
  };

  const onSaveClick = async () => {
    try {
      setSubmitLoader(true);
      const obj = [
        {
          Id: data?.id ?? 0,
          ProjectId: Number(data?.projectId ?? 0),
          CompanyId: data?.companyId ?? 0,
          CreatedBy: Number(currentUserId),
          DateCreated: moment().format(),
          DateModified: moment().format(),
          ModifiedBy: Number(currentUserId),
          ProjectCompanyRoleId: roleId,
          OtherProjectCompanyRole: otherRoleName
        }
      ];
      await Postrequestcall(SAVE_PROJECTS_COMPAINES, obj, loginData?.accessToken);
      onDataSave();
    } catch (error) {
      setSubmitLoader(false);
      console.log("onSaveClick-> Error Saving Project Companies: ", error);
    }
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6" sx={{ ml: 1 }}>
            {TEXT_ADD_COMPANY_ROLE}
          </Typography>
          <Stack direction={"row"}>
            <IconButton onClick={() => onClose()}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>
        <Stack spacing={1.5}>
          <Card className="pagelist-content" sx={{ p: 2 }}>
            <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={1}>
              <Typography variant="h6">{TEXT_LABEL_PROJECT} :</Typography>
              <Typography variant="body1">{data?.projectName ?? ""}</Typography>
            </Stack>
          </Card>
          <Typography sx={{ alignSelf: "center" }} variant="body1">
            {TEXT_LET_KNOW_COMPANY_ROLE_PLAYED}
          </Typography>
          <Card className="pagelist-content" sx={{ p: 2 }}>
            <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={1}>
              <Typography variant="h6">{TEXT_COMPANY_NAME} :</Typography>
              <Typography variant="body1">{data?.companyName ?? ""}</Typography>
            </Stack>
          </Card>
          <Box
            sx={{
              height: "310px",
              overflow: "auto",
              scrollbarWidth: "none"
            }}>
            <Stack spacing={2}>
              <Autocomplete
                sx={{ pt: 0.5 }}
                freeSolo
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                  let inputValue = newInputValue;
                  inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                  setInputValue(inputValue);
                }}
                label="Roles"
                id="Roles"
                options={rolesData}
                onChange={(event, newValue) => {
                  if (newValue && newValue.name == "Other") {
                    setOtherValFlag(true);
                    setRoleId(newValue?.id);
                  } else {
                    setOtherValFlag(false);
                    setRoleId(newValue?.id);
                  }
                }}
                getOptionLabel={(option) => `${option?.name}`}
                style={{ flex: 1 }}
                renderInput={(params) => {
                  return (
                    <>
                      <TextField {...params} label={TEXT_ROLES} variant="outlined" />
                    </>
                  );
                }}
              />
              {otherValFlag ? (
                <TextField
                  label="New Role"
                  variant="outlined"
                  onChange={(event) => {
                    let inputValue = event.target.value;
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                    setOtherRoleName(inputValue);
                  }}
                />
              ) : (
                <></>
              )}
            </Stack>
          </Box>
          <Button
            color="primary"
            loading={submitLoader}
            variant="contained"
            onClick={onSaveClick}
            disabled={otherValFlag ? !otherRoleName.trim() : !roleId}>
            {BUTTON_SAVE}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default AddRoleToCompanyModal;
